import { JDSDropdownMenuItemMobileProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDropdownMenuItemMobileProps>
  ): React.FC<JDSDropdownMenuItemMobileProps> =>
  (props: JDSDropdownMenuItemMobileProps) => {
    return <Component {...props} />;
  };
